var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('iframe',{staticStyle:{"width":"100%","height":"1200px"},attrs:{"id":"panda","src":'https://app.pandadoc.com/a/#/document/v1/editor/'+_vm.opportunity.quote.uuid+'/content'}})])}
var staticRenderFns = []

export { render, staticRenderFns }